import React from "react";
import icon_lock from "../../assets/icons/icon-lock.svg";
import { showWarningMessage } from "../../utils/notification";
import { useAuthContext } from "../../context/providers/AuthContext";
const PasswordForm = ({ userAuthenticated }) => {
	//init password data
	const [passwordData, setPasswordData] = React.useState({
		password: "",
		newPassword: "",
	});

	const [enablePaswwordButton, setEnablePaswwordButton] = React.useState(true);

	const { password, newPassword } = passwordData;
	const { updateProfile } = useAuthContext();
	/**Methods */

	const handlePasswordFieldsChange = (e) => {
		if (password === "" && newPassword === "") {
			setEnablePaswwordButton(true);
		} else {
			setEnablePaswwordButton(false);
		}
		setPasswordData({ ...passwordData, [e.target.name]: e.target.value });
		if (e.target.name === "newPassword") {
			console.log(e.target.value);
		}
	};

	const handlePasswordFormSubmit = (e) => {
		e.preventDefault();
		if (password === newPassword) {
			showWarningMessage("Passwords must be different,Please try again");
		} else {
			console.log(passwordData);
			updateProfile(userAuthenticated._id, passwordData);
			setEnablePaswwordButton(true);
		}
	};

	return (
		<form onSubmit={handlePasswordFormSubmit}>
			<div className="d-md-flex">
				<div className="input__field mt-3 w-100 mt-md-4">
					<label htmlFor="password" className="input__label">
						Current password
					</label>
					<div className="input__group">
						<input
							type="password"
							name="password"
							value={password}
							className="input input--primary input--with_icon"
							autoComplete="new-password"
							onChange={handlePasswordFieldsChange}
							required
						/>
						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_lock} alt="" />
						</div>
					</div>
				</div>

				<div className="input__field mt-3 w-100 mt-md-4 ml-md-3">
					<label htmlFor="second_name" className="input__label">
						New password
					</label>
					<div className="input__group">
						<input
							type="password"
							name="newPassword"
							value={newPassword}
							className="input input--primary input--with_icon"
							autoComplete="new-password"
							onChange={handlePasswordFieldsChange}
							minLength={5}
							maxLength={15}
							required
						/>

						<div className="input__icon d-flex align-items-center justify-content-center">
							<img src={icon_lock} alt="" />
						</div>
					</div>
				</div>
			</div>
			<div className="d-flex justify-content-center mt-5">
				<button className="btn btn--primary w-100" type="submit" disabled={enablePaswwordButton}>
					Submit
				</button>
			</div>
		</form>
	);
};

export default PasswordForm;
